module.exports = __webpack_public_path__ + "img/first_zhTc.6097608f.png";